import BaseEvent from "ol/events/Event";
import { CommonEvents } from "./CommonEvents";

export default class DeleteTrackEvent extends BaseEvent {
    trackId: string;
    addUndoCommand: boolean
    constructor(trackId: string, addUndoCommand: boolean) {
        super(CommonEvents.DeleteTrack)
        this.trackId = trackId
        this.addUndoCommand = addUndoCommand
    }

}